import React from 'react';
const stats = [{
  value: '+800',
  label: 'familias'
}, {
  value: '3',
  label: 'Tomos'
}, {
  value: '6',
  label: 'Bonos'
}, {
  value: '4.9/5',
  label: 'valoración ⭐'
}];
export function ProofStrip() {
  return <section className="w-full border-y border-forest/10 bg-cream-card" data-id="element-149" data-mp="3bbxff1zaylxk">
      <ul className="mx-auto grid max-w-4xl grid-cols-2 divide-forest/10 px-5 py-6 sm:px-8 md:grid-cols-4 md:divide-x" data-id="element-150" data-mp="36cb44y31bfre">
        {stats.map(s => <li key={s.label} className="px-4 py-3 text-center" data-id="element-151" data-mp="7tdxote92yh0">
            <p className="font-display text-2xl font-semibold text-forest sm:text-3xl" data-id="element-152" data-mp="2usxgtz00esk">
              {s.value}
            </p>
            <p className="mt-0.5 text-sm text-forest-dark/60" data-id="element-153" data-mp="3tzsow9nvtdkv">{s.label}</p>
          </li>)}
      </ul>
    </section>;
}